// Base response interfaces (extracted and enhanced from OrderDetails.tsx)
export interface ItemResponse {
  id: number;
  name: string;
  tax?: number;
  formula?: number;
  genericName?: string;
  jkl?: string;
  atc?: string;
  shape?: string;
  intensity?: string;
  packageShape?: string;
  packageQuantity?: string;
  itemLoyaltyPoints?: number;
  itemLoyaltyPointsMedic?: number;
  averageRate?: number;
  numOfRates?: number;
  rfzoPrice?: number;
  rfzoParticipationPrice?: number;
  manufacturerId?: number;
  manufacturerName?: string;
  manufacturerState?: string;
  files?: string[];
  itemAvailability?: string;
  itemAvailabilityCode?: string;
  itemAvailabilityShortCode?: string;
  itemAvailabilityDescription?: string;
  itemAvailabilityColor?: string;
  itemAvailabilityNeedRP?: boolean;
  itemEANs?: string[];
  licenceHolderResponse?: any; // Keep as any for now
  commonGroups?: any[];
  therapyIndications?: any[];
  images?: string[];
}

export interface OrderItem {
  quantity: number;
  itemExternalName?: string;
  itemResponse: ItemResponse;
  priceWithoutDiscount: number;
  price: number;
  unitPriceWithoutDiscount: number;
  unitPrice: number;
  rfzoParticipationPrice?: number;
  rfzoQuantity?: number;
}

export interface RFZOItem {
  quantity: number;
  itemResponse: ItemResponse;
  rfzoParticipationPrice: number;
  rfzoQuantity: number;
  unitPrice: number;
}

export interface UserResponse {
  id: number;
  username: string;
  nickname?: string;
  firstName: string;
  secondName: string;
  phoneNumber: string;
  userPhoto?: string;
  personalIdType?: string;
  personalId?: string;
  bankAccount?: string;
  locale?: string;
  permitAdvertising?: boolean;
  privacyPolicy?: boolean;
  privacyPolicyForAssociation?: boolean;
  userAddresses?: any[];
  userMedicLicenceResponses?: any[];
  userLoyaltyPoints?: number;
  lbo?: string;
  appBrand?: AppBrandResponse;
}

export interface UserAddressResponse {
  id: number;
  name: string;
  number: string;
  apartment?: string;
  floor?: string;
  region?: string;
  city: string;
  postalCode?: string;
  latitude: number;
  longitude: number;
  otherInformation?: string;
}

export interface TimeSlotResponse {
  start: string;
  end: string;
  day: string;
  hoursSlot: string;
}

export interface PrescriptionResponse {
  url: string;
}

export type OpeningHoursDay =
  | "monday"
  | "tuesday"
  | "wednesday"
  | "thursday"
  | "friday"
  | "saturday"
  | "sunday";

export interface OpeningHoursResponse {
  monday?: string | null;
  tuesday?: string | null;
  wednesday?: string | null;
  thursday?: string | null;
  friday?: string | null;
  saturday?: string | null;
  sunday?: string | null;
}

export interface MarketplaceResponse {
  marketplaceId: number;
  branchMarketplaceId: number;
  marketplaceUserEmail?: string;
  name: string;
  meaningfulName?: string;
  phoneNumber?: string;
  email?: string;
  website?: string;
  address?: string;
  location?: string;
  postalCode?: number;
  shortDescription?: string;
  description?: string;
  open?: number;
  isApotekaRs?: number;
  isClickAndCollect?: number;
  takesOrders?: number;
  haveDelivery?: number;
  deliveryPrice?: number;
  deliveryPriceFast?: number;
  haveRFZO?: number;
  deleted?: number;
  longitude?: number;
  latitude?: number;
  averageOrderProcessedTime?: number;
  numOfProcessedOrders?: number;
  averageRate?: number;
  numOfRates?: number;
  numOfItemsWithDiscount?: number;
  boIpAddress?: string;
  branchMarketplaceResponse?: any; // Could be further typed
  openingHoursResponse?: OpeningHoursResponse | null;
  files?: any[]; // Could be further typed as FileResponse[]
  marketplacePharmacyLicenseResponse?: any; // Could be further typed
  pictures?: string[]; // Deprecated but still used
}

export interface AppBrandResponse {
  id: number;
  name: string;
  branchMarketplaceId?: number | null;
  logo?: string;
}

// Shared schedule vocabulary (ITAM-2887): the volunteer and the advisor
// working-hours editors use the same seven-day shape, so both page types
// alias these.
export type DayOfWeek =
  | "MONDAY"
  | "TUESDAY"
  | "WEDNESDAY"
  | "THURSDAY"
  | "FRIDAY"
  | "SATURDAY"
  | "SUNDAY";

export interface WorkingHoursEntry {
  dayOfWeek: DayOfWeek;
  /** Strictly "HH:mm"; the backend's @JsonFormat rejects "08:00:00" with a 400. */
  availableFrom: string;
  availableUntil: string;
}

export const DAYS_OF_WEEK: DayOfWeek[] = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const DAY_OF_WEEK_LABELS: Record<DayOfWeek, string> = {
  MONDAY: "Ponedeljak",
  TUESDAY: "Utorak",
  WEDNESDAY: "Sreda",
  THURSDAY: "Četvrtak",
  FRIDAY: "Petak",
  SATURDAY: "Subota",
  SUNDAY: "Nedelja",
};
